import { render, staticRenderFns } from "./productvariety.vue?vue&type=template&id=d797367c&scoped=true&"
import script from "./productvariety.vue?vue&type=script&lang=js&"
export * from "./productvariety.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d797367c",
  null
  
)

export default component.exports